// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__AG9q5","header":"ReportDetails_header__3VRMw","title":"ReportDetails_title__385e-","left":"ReportDetails_left__26JK4"};